<article class="ticket-card" [class.new-ticket]="isNewTicket" [routerLink]="['/', Routenames.TtmTickets, ticket.id]">
    <header class="ticket-card-header">
        <h2 class="ticket-user-name">
            @if (isNewTicket) {
                <i class="fa-regular fa-triangle-exclamation new-ticket-icon" matTooltip="Nieuw ticket dat nog niet is bekeken"></i>
            }
            {{ticket.user?.name || 'Onbekende gebruiker'}}</h2>
        <span class="department-chip">{{ticket.department | TtmTicketDepartment}}</span>
        <span class="ticket-type"><span class="subheader-separator">•</span> {{ticket.type | TtmTicketType}}</span>
    </header>

    <div class="ticket-card-actions">
        <div class="status-badge" [ngClass]="'status-' + ticket.status">{{ticket.status | TtmTicketStatus}}</div>

        <button mat-icon-button type="button"
                (click)="$event.stopPropagation(); toggleMuteNotifications()"
                [matTooltip]="ticket.is_muted?.email_enabled ? 'Notificaties staan aan' : 'Notificaties zijn gedempt'"
                matTooltipTouchGestures="off">
            <i class="fa-regular" [ngClass]="ticket.is_muted?.email_enabled ? 'fa-bell' : 'fa-bell-slash'"></i>
        </button>

        <button mat-icon-button type="button" [matMenuTriggerFor]="ticketActionsMenu" (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #ticketActionsMenu="matMenu">
            @if (ticket.ttm_id) {
                <a mat-menu-item
                   routerLink="/{{Routenames.Projects}}/{{ticket.ttm?.project_id}}"
                   [queryParams]="{ttm: ticket.ttm_id, drawing: ticket.ttm?.entities[0]?.drawings[0]?.id}">
                    <mat-icon>open_in_new</mat-icon>
                    <span>Openen TVM</span>
                </a>
            } @else if (ticket.workorder_id) {
                <a mat-menu-item
                   routerLink="/{{Routenames.WorkOrders}}"
                   [queryParams]="{workorderId: ticket.workorder_id}">
                    <mat-icon>open_in_new</mat-icon>
                    <span>Openen werkopdracht</span>
                </a>
            }

            @if (ticket.user_id === LocalStorage.user?.id || (Roles.Codalt | hasRole)) {
                <button mat-menu-item type="button" (click)="deleteTicket.emit(ticket)">
                    <mat-icon>delete</mat-icon>
                    <span>Verwijderen</span>
                </button>
            }
        </mat-menu>
    </div>

    <div class="ticket-card-body">
        <div class="ticket-field">
            <i class="fa-regular fa-calendar field-icon"></i>
            <div class="field-content">
                <span class="field-label">Aangemaakt</span>
                <span class="field-value">{{ticket.created_at | date: 'EEE d MMM yyyy HH:mm'}}</span>
            </div>
        </div>

        <div class="ticket-field">
            <i class="fa-regular fa-user field-icon"></i>
            <div class="field-content">
                <span class="field-label">Toegewezen aan</span>
                <span class="field-value">{{ticket.assignee?.name || 'Niet toegewezen'}}</span>
            </div>
        </div>

        @if (ticket.ttm_id) {
            <div class="ticket-field ticket-field-wide">
                <i class="fa-regular fa-location-dot field-icon"></i>
                <div class="field-content">
                    <span class="field-label">TVM</span>
                    <span class="field-value" [title]="$any(ticket.ttm)?.project?.name + ' - #' + ticket.ttm_id">{{$any(ticket.ttm)?.project?.name}} - #{{ticket.ttm_id}}</span>
                </div>
            </div>
        } @else if (ticket.workorder_id) {
            <div class="ticket-field ticket-field-wide">
                <i class="fa-regular fa-location-dot field-icon"></i>
                <div class="field-content">
                    <span class="field-label">Werkopdracht</span>
                    <span class="field-value">{{ticket.workorder?.id_4ps ?? ticket.workorder?.source_no ?? ticket.workorder_id}}</span>
                </div>
            </div>
        }

        <div class="ticket-field ticket-field-wide">
            <i class="fa-regular fa-comment field-icon"></i>
            <div class="field-content">
                <span class="field-label">Opmerking</span>
                <p class="field-value comment-clamp" [title]="ticket.comment || ''">{{ticket.comment || '-'}}</p>
            </div>
        </div>
    </div>
</article>
